import Counter from '@/helpers/Counter'
import FlashMessageComponent from '@/components/widgets/flash-messages/FlashMessages'

let maxVisibleTimeout

export default {
    install: function (Vue, pluginOptions = {}) {
        Vue.component(FlashMessageComponent.name, FlashMessageComponent)

        Vue.prototype.$flashMessages = Vue.observable({})

        Vue.prototype.$manageFlashMessagesHops = function (container = 'default') {
            if ( ! this.$flashMessages[container]) {
                Vue.set(this.$flashMessages, container, {})
            }

            let messages = this.$flashMessages[container]

            Object.keys(messages).forEach(messageId => {
                if (messages[messageId].hops <= 0) {
                    Vue.prototype.$hideFlashMessage(messageId, container)
                } else {
                    messages[messageId].hops--
                }
            })
        }

        Vue.prototype.$addFlashMessage = function (message, type = 'error', hops = 0, options) {
            let msg = Object.assign({
                content: message,
                type,
                hops,

                container: 'default',
                escape: true,
                clear: false,
                maxVisibleMessages: undefined,
                timeout: false
            }, options)

            // check container if not exist create it
            if ( ! this.$flashMessages[msg.container] || msg.clear ) {
                Vue.set(this.$flashMessages, msg.container, {})
            }

            const uniqueIndexer = new Counter(`flash-messages-${msg.container}`)

            // fixed issue when adding flash messages before oc-flash-messages component is initialized were hidden
            setTimeout(() => {
                Vue.set(this.$flashMessages[msg.container], `${uniqueIndexer.key}-${uniqueIndexer.increment()}`, msg)

                // manage maxVisibleMessages
                let keys = Object.keys(this.$flashMessages[msg.container])

                let maxVisibleMessages = msg.maxVisibleMessages

                if( maxVisibleMessages === undefined ) {
                    maxVisibleMessages = pluginOptions.maxVisibleMessages
                }

                if( maxVisibleMessages === undefined ) {
                    maxVisibleMessages = 5
                }

                if( maxVisibleMessages > 0 && keys.length > maxVisibleMessages )
                {
                    if( maxVisibleTimeout ) {
                        clearTimeout(maxVisibleTimeout)
                    }

                    maxVisibleTimeout = setTimeout(() => {
                        keys = keys.map(item => {
                            return parseInt(item.match(/\d+/)[0])
                        }).sort((a, b) => a - b)

                        keys.slice(0, -maxVisibleMessages).forEach(key => {
                            this.$hideFlashMessage(`${uniqueIndexer.key}-${key}`, msg.container)
                        })
                    }, 0)
                }
                //
            }, 0)

            if ( msg.timeout !== false && msg.timeout > 0 ) {
                let msgIndex = `${uniqueIndexer.key}-${uniqueIndexer.get()}`
                setTimeout(() => {
                    this.$hideFlashMessage(msgIndex, msg.container)
                }, msg.timeout * 1000)
            }
        }

        Vue.prototype.$hideFlashMessage = function (messageId = false, container = 'default') {
            if (messageId !== false &&
                this.$flashMessages[container] &&
                this.$flashMessages[container][messageId]
            ) {
                Vue.delete(this.$flashMessages[container], messageId)
                return
            }

            if (this.$flashMessages[container]) {
                Vue.set(this.$flashMessages, container, {})
            }
        }
    }
}
